"use strict";

var _regeneratorRuntime = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAsync = void 0;

var isNode = require("detect-node");

require("isomorphic-fetch"); // WARNING: This needs to be imported after isomorphic-fetch: https://github.com/mo/abortcontroller-polyfill#using-it-on-browsers-without-fetch
// tslint:disable-next-line:ordered-imports


require("abortcontroller-polyfill/dist/abortcontroller-polyfill-only");

var fetchAsync = function fetchAsync(endpoint) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timeoutMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20000;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var optionsWithAbortParam, controller, signal, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(options.signal || options.timeout)) {
              _context.next = 2;
              break;
            }

            throw new Error('Cannot call fetchAsync with options.signal or options.timeout. To set a timeout, please use the supplied "timeoutMs" parameter.');

          case 2:
            if (!isNode) {
              controller = new AbortController();
              signal = controller.signal;
              setTimeout(function () {
                controller.abort();
              }, timeoutMs);
              optionsWithAbortParam = Object.assign({
                signal: signal
              }, options);
            } else {
              // HACK: the `timeout` param only exists in `node-fetch`, and not on the `isomorphic-fetch`
              // `RequestInit` type. Since `isomorphic-fetch` conditionally wraps `node-fetch` when the
              // execution environment is `Node.js`, we need to cast it to `any` in that scenario.
              optionsWithAbortParam = Object.assign({
                timeout: timeoutMs
              }, options);
            }

            _context.next = 5;
            return fetch(endpoint, optionsWithAbortParam);

          case 5:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.fetchAsync = fetchAsync;